export enum PaymentOption {
  STRIPE = 'stripe',
  PLACETOPAY = 'placetopay',
  NONE = 'none'
}

export const ConfiguracionPagoTarjeta = {
 intentos_pago_tarjeta: 2,
 intentos_pago_placetopay: 2,
 intervalo_consulta_placetopay_ms: 10000,
};
